var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext } from 'react';
import { Redirect, Route } from 'react-router-dom';
import { UserContext } from '../Auth/UserProvider';
var ProtectedRoute = function (_a) {
    var render = _a.render, _b = _a.roles, roles = _b === void 0 ? [] : _b, rest = __rest(_a, ["render", "roles"]);
    var _c = useContext(UserContext), user = _c.user, twoFactorConfirmed = _c.twoFactorConfirmed;
    var authenticated = user && twoFactorConfirmed;
    return (React.createElement(Route, __assign({}, rest, { render: function (props) { return ((authenticated && (roles.length == 0 || roles.indexOf(user.role) > -1)) ? render(props) : React.createElement(Redirect, { to: "/" })); } })));
};
export default ProtectedRoute;
